<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="mb-0">Предметы</h1>
    </div>
    <br>

    <table class="table table-borderless" v-if="subjects && subjects.length > 0">
      <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">Название предмета</th>
          <th scope="col">Количество учеников</th>
          <th scope="col">Статус</th>
          <th scope="col">Тип</th>
          <th scope="col">Оплата</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(subject, index) in subjects" :key="subject.id">
          <td>{{ index + 1 }}</td>
          <td><router-link :to="{ name: 'admin-subject', params: { id: subject.slug }}">{{ subject.title }}</router-link></td>
          <td>{{ subject.country }}</td>
          <td><span class="text-success" v-if="subject.isActive">Активный</span><span v-else>Неактивный</span></td>
          <td>{{ subject.isExam }}</td>
          <td><svg v-if="!subject.isFree" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></td>
          <td><router-link :to="{ name: 'admin-subject', params: { id: subject.slug }}"><img src="/static/images/icons/edit.svg" alt=""></router-link></td>
        </tr>
      </tbody>
    </table>
    <br>
    <p class="text-center">
      <a href="#" @click.prevent="openEditModal(false)" class="btn bg-lighter">
        Добавить предмет
      </a>
    </p>
    <hr class="space space-sm">
    <subject-add ref="modal" :item="editSubject" @update="update"></subject-add>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubjectAdd from './Includes/SubjectAddModal'

export default {
  name: 'subjects',
  components: {
    subjectAdd: SubjectAdd
  },
  data () {
    return {
      editSubject: null
    }
  },
  computed: {
    ...mapState({
      subjects: state => state.managers.subjects
    })
  },
  methods: {
    openEditModal (item) {
      if (item) {
        this.editSubject = item
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      } else {
        this.editSubject = null
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      }
    },
    update () {
      this.$store.dispatch('GET_SUBJECT', this.id)
      this.$refs.modal.hideModal()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('GET_SUBJECTS')

    if (this.user && !this.user.isAdmin) {
      this.$router.push({ name: 'profile' })
    }
  }
}
</script>